import React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';

export interface CheckboxProps {
    inputName?: string;
    disabled?: boolean;
    checked: boolean;
    label: string;
    caption?: string;
    onChange: (season: string) => void;
}

interface StyledCheckboxProps extends JSSClassesProps<ComponentJSSClasses>, CheckboxProps {}

export function Checkbox(props: StyledCheckboxProps) {
    const { classes, checked, disabled, caption, onChange, label, inputName } = props;

    const renderCheckIcon = (checked: boolean): JSX.Element => {
        return (
            <svg
                className={`${classes.checkbox} ${checked ? classes.checkboxActive : ''} `}
                aria-hidden="true"
                viewBox="0 0 15 11"
                fill="none"
            >
                <path d="M1 4.5L5 9L14 1" strokeWidth="2" stroke={checked ? 'white' : 'none'} />
            </svg>
        );
    };

    return (
        <label className={classes.label}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                className={classes.input}
                onChange={() => onChange(label)}
            />
            {renderCheckIcon(checked)}
            <span className={classes.inputText}>
                {inputName}
                {caption && <span className={classes.caption}>{caption}</span>}
            </span>
        </label>
    );
}
